module.exports = __webpack_public_path__ + "img/vehicle-slides-with-backdrop-infiniti.1ee0ba1a.png";